import React from "react";
import {
  Main,
  MainBody,
  Gradient,
  Sidebar,
  Navigation,
  NavigationSection,
  NavigationItem,
  NavigationGroup,
  Profilebar,
} from "@kerberos-io/ui";
import "./App.css";
import logo from "./header-minimal-logo-36x36.svg";
import "@kerberos-io/ui/lib/index.css";
import { logout } from "./actions";
import { connect } from "react-redux";
import config from "./config";

class App extends React.Component {
  render() {
    return (
      <div id={"page-root"}>
        <Sidebar
          logo={logo}
          title="Kerberos Vault"
          version={config.VERSION}
          mobile={true}
        >
          <Profilebar
            username={this.props.username}
            email={"support@kerberos.io"}
            userrole={"admin"}
            logout={this.props.dispatchLogout}
          />
          <Navigation>
            <NavigationSection title={"monitoring"} />
            <NavigationGroup>
              <NavigationItem
                title={"Dashboard"}
                icon={"dashboard"}
                link={"dashboard"}
              />
              <NavigationItem title={"Media"} icon={"media"} link={"media"} />
              <NavigationItem
                title={"Cameras"}
                icon={"cameras"}
                link={"cameras"}
              />
              {/*<NavigationItem
                title={"Vaults"}
                icon={"cameras"}
                link={"vaults"}
              />
              <NavigationItem
                title={"Activity log"}
                icon={"activity"}
                link={"activity"}
              /> */}
            </NavigationGroup>
            <NavigationSection title={"management"} />
            <NavigationGroup>
              <NavigationItem
                title={"Storage Providers"}
                icon={"cloud"}
                link={"providers"}
              />
              <NavigationItem
                title={"Integrations"}
                icon={"counting"}
                link={"queues"}
              />
              <NavigationItem
                title={"Accounts"}
                icon={"accounts"}
                link={"accounts"}
              />
            </NavigationGroup>
            <NavigationSection title={"help & support"} />
            <NavigationGroup>
              <NavigationItem
                title={"Swagger API docs"}
                icon={"api"}
                external={true}
                link={config.API_URL + "swagger/index.html"}
              />
              <NavigationItem
                title={"Documentation"}
                icon={"book"}
                external={true}
                link={"https://doc.kerberos.io/vault/first-things-first"}
              />
              <NavigationItem
                title={"Github"}
                icon={"github-nav"}
                external={true}
                link={"https://github.com/kerberos-io/vault"}
              />
            </NavigationGroup>
          </Navigation>
        </Sidebar>
        <Main>
          <Gradient />
          <MainBody>{this.props.children}</MainBody>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  username: state.auth.username,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchLogout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
